// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZcXO","inner":"styles_inner__3Ke8g","right":"styles_right__awkwd","close":"styles_close__bADaK","footer":"styles_footer__3b3iQ"};